import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-events-form',
  templateUrl: './edit-events-form.component.html',
  styleUrls: ['./edit-events-form.component.scss']
})
export class EditEventsFormComponent implements OnInit {

  constructor() {}

  ngOnInit() {};
}